import React, { createContext, useState, useEffect, useContext } from "react";
import { EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK, WORKHISTORY_LINK } from "../constants/constants";
import _ from "lodash";
import axios from "axios";

const ResumeContext = createContext({});

export const ResumeProvider = (props) => {
    const [showPreview, setShowPreview] = useState(false);
    const [generalPhrases, setGeneralPhrases] = useState(null);
    const [headingPhrases, setHeadingPhrases] = useState(null);
    const [workHistoryPhrases, setWorkHistoryPhrases] = useState(null);
    const [eductionHistoryPhrases, setEductionHistoryPhrases] = useState(null);
    const [skillPhrases, setSkillPhrases] = useState(null);
   //check all shared props + container for below files
    // wp-content/themes/resumebuilder/builder/src/initial-data.jsx
    // wp-content/themes/resumebuilder/builder/src/containers/EditorContainer.jsx
    // const resume = props.resume
    // const handlers = props.handlers
    // const { 
    //     resume, 
    //     handlers, 
    //     next_label,
    //     next_clicked,
    //     back_clicked,
    //     skip_clicked,
    //     skip_label,
    //     unskip_clicked,
    //     redirect_to,
    //     loginHash,
    //     user,
    //     job_category,
    // } = props
    const toggleSkip = name => {
        console.log('toggleee skip')
        let skipped_sections_temp = props.resume.skipped_sections == undefined ? [] : props.resume.skipped_sections;
        if(!props.resume.skipped_sections?.includes(name)){//Add to skip list
            skipped_sections_temp.push(name)
            props.handlers.updateResumePreview(
                { skipped_sections: [...skipped_sections_temp] },true
             )
             props.handlers.nuteralizeNextClick({skip_label: 'Add'});
            gaTrack('RB App', `Editor`, `Skip: ${name}`);
            let ga_cat = 'app_editor_skip_' + (name).replace(' ', '_');
            ga4Track(ga_cat, 'RB App', `Skip: ${name}`);
            return true
        }else { // undo skip
            //skipped_sections_temp.pop(name)
            const index = skipped_sections_temp.indexOf(name);
            if(index > -1){ // only splice array when item is found
                skipped_sections_temp.splice(index, 1); // 2nd parameter means remove one item only
            }
            props.handlers.updateResumePreview(
                { skipped_sections: [...skipped_sections_temp] },true
             )
             props.handlers.nuteralizeNextClick({skip_label: 'Skip'});
            return false
        }
    }

    
    const toggleProfilePicture = () => {
        // const { resume } = props;
        // delete resume.heading.profile_picture.picture_path;
        // delete resume.heading.profile_picture.picture_abs_path;
        // props.handlers.updateResumePreview(
        //     {
        //         ...props.resume,
        //         resume: resume
        //     }
        // );

        let show_profile_picture_tmp = (
            !props.resume.heading?.show_profile_picture 
            ? true 
            : props.resume.heading.show_profile_picture
        );
    
        show_profile_picture_tmp = (
            (!props.resume.heading.show_profile_picture 
            || props.resume.heading.show_profile_picture == undefined)
            ? true
            : false
        );

        props.handlers.updateResumePreview(
            {
                heading: {
                    ...props.resume.heading, 
                    show_profile_picture: show_profile_picture_tmp
                }
            }, true
        );

        return show_profile_picture_tmp;
    }
    const hasReviewSuggestions = (section, field, row_id = null) => {
       return  Object.keys(reviewSuggestions(section, field, row_id)).length >  0 
    }
    const reviewSuggestions = (section, field, row_id = null) => {
        let r = props.resume?.resume_review;
        if (r) {//Fit in case data not found
            r = r[section]
            //Proceed only when error is set
            if (r) if (row_id && r?.rows?.[row_id]?.errors[field]) {
                return filterIgnoredSuggestions(r.rows[row_id].errors, field)
            } else if (r?.errors[field]) {
                return filterIgnoredSuggestions(r.errors, field)
            }else
                return {}
        }
    }
    const filterIgnoredSuggestions = (errors, field = null) => {
        const _eachRow = _errors => {
            const c = {}
            Object.keys(_errors).map((v) => (_errors[v].ignored === "false" || _errors[v].ignored === false) && (c[v] = _errors[v]))
            return c
        }
        if(field){
            return _eachRow(errors[field])
        }else{//row is field level
            let _result = {}
            Object.keys(errors).map(key  => {
                const temp = _eachRow(errors[key])
                return Object.keys(temp).length > 0 && (_result[key] = temp)  
            })
            return _result
        }
    }
    const ignoreIt = (section, error, word = null) => {
        let resume = props.resume;
        let rr = resume.resume_review, field = error['field'], error_key = error['error_key'], row_id = error['parent_key']
        if(rr['additional_sections']?.[section]){
            rr['additional_sections'][section]
        }else if(rr[section]){
            if(word){//specific to spell check
                if(row_id){
                    const ilist = rr[section].rows?.[row_id].errors[field][error_key].ignored_list
                    if(ilist) rr[section].rows[row_id].errors[field][error_key].ignored_list.push(word)
                    else rr[section].rows[row_id].errors[field][error_key].ignored_list = [word]
                }else{
                    const ilist = rr[section].errors[field][error_key].ignored_list
                    if(ilist) rr[section].errors[field][error_key].ignored_list.push(word)
                    else rr[section].errors[field][error_key].ignored_list = [word]
                }
            }else if(row_id){
                rr[section].rows[row_id].errors[field][error_key].ignored = true
            }else{
                rr[section].errors[field][error_key].ignored = true
            }
            props.handlers.resumeReview(resume)
        }
    }

    //Feature is related to AI review functionality
    const scanReviewSuggestions = (section_id, row_id = null, all = false ) => {
        let group = {}
        const section = props.resume?.resume_review[section_id];
        section?.errors && (group = { ...filterIgnoredSuggestions(section?.errors) })
        if (props.section?.id == 'additional_sections') {//Go one level deeper
            Object.values(section).map((each, k1) => {
                if (each?.rows) {//handle multi row section
                    Object.values(each.rows).map((each1, k2) => {
                        group = { ...group, ...each1.errors }
                    })
                } else if (each?.errors) {
                    group = { ...group, ...each.errors }
                }
            })
        } else {// multi level sections
            if(all && section?.rows){
                Object.values(section?.rows).map(row => {
                    group = { ...group, ...filterIgnoredSuggestions(row.errors) }
                })
            }else if(row_id){
            //Check if any section opened, will only show for those errors
                const opened_row = row_id
                if (opened_row && section?.rows?.[opened_row]) {
                    group = { ...group, ...filterIgnoredSuggestions(section?.rows[opened_row].errors) }
                }
            }
        }
        return group

    }
    
    //Feature is prepared to get id for scroll on field feature, when user clicked on view error button in error popup.(only for mobile)
    const getFieldSuggestionId = (section, field, row_id = null) => {
        const r = props.resume?.resume_review;
        let errorData = '';
        if(r) if(row_id && r[section]?.rows?.[row_id]?.errors[field]){
                errorData =  `section_${row_id}_${field}`;
            }else if(r[section]?.errors[field]){
                errorData = `section_${field}`;
            }else{
                errorData = '';
            }
            return errorData;
    }
    
    const getGeneralPhrases = () => {
        return new Promise((resolve, reject) => {
            if(generalPhrases != null){
                resolve([...generalPhrases])
            }else{
                axios.get('/assets/data/phrases-general.json')
                .then(response => {
                    const res = response.data
                    setGeneralPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const getHeadingPhrases = () => {
        return new Promise((resolve, reject) => {
            if(headingPhrases != null){
                resolve([...headingPhrases])
            }else{
                axios.get('/assets/data/phrases-heading.json')
                .then(response => {
                    const res = response.data
                    setHeadingPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const getWorkHistoryPhrases = () => {
        return new Promise((resolve, reject) => {
            if(workHistoryPhrases != null){
                resolve([...workHistoryPhrases])
            }else{
                axios.get('/assets/data/phrases-work-history.json')
                .then(response => {
                    const res = response.data
                    setWorkHistoryPhrases([...res]);
                    resolve([...res])
                })
            }
        });
    }

    const getEducationHistoryPhrases = () => {
        return new Promise((resolve, reject) => {
            if(eductionHistoryPhrases != null){
                resolve([...eductionHistoryPhrases])
            }else{
                axios.get('/assets/data/phrases-education.json')
                .then(response => {
                    const res = response.data
                    setEductionHistoryPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const getSkillsPhrases = () => {
        return new Promise((resolve, reject) => {
            if(skillPhrases != null){
                resolve([...skillPhrases])
            }else{
                axios.get('/assets/data/phrases-skills.json')
                .then(response => {
                    const res = response.data
                    setSkillPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const fetchPhrases = () => {
        getGeneralPhrases();
        getHeadingPhrases();
        getWorkHistoryPhrases();
        getEducationHistoryPhrases();
        getSkillsPhrases();
    }

    const getDefaultPhrases = (section = '', callback = false) => {
        if(section == '') return
        switch(section){
            case 'heading':
            case 'work_history':
            case 'skills':
                getGeneralPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'education_history':
                getEducationHistoryPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            default:
                //do nothing..
                break;
        }
    }

    const getPhrases = (section = '', callback = false) => {
        if(section == '') return
        switch(section){
            case 'heading':
                getHeadingPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'work_history':
                getWorkHistoryPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'education_history':
                getEducationHistoryPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'skills':
                getSkillsPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            default:
                //do nothing..
                break;
        }
    }
    // trigger suggestion popup
    const showSuggestionPopup = (element_id) => {
        if (window.innerWidth <= 767) {
            //setTimeout added to give time for popup to open and then scrollTo error
            setTimeout(() => {
                const targetElement = document.querySelector(`[data-suggestion-id="${element_id}"]`);
                targetElement && targetElement.scrollIntoView({behavior: 'smooth',blockOffset: -100,block: 'center'});
            }, 100);
            const errBtnIcon = document.getElementById('show-err-box');
            errBtnIcon && errBtnIcon.click();
        }
    };

    useEffect(() => {
        //on page load, phrases will be set from JSON file
        fetchPhrases();
    }, []);

    // const skipLabel = () => {
    //     if([WORKHISTORY_LINK, EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK].includes(location.pathname)){

    //     }
    // }

    return (
        <ResumeContext.Provider value={{...props, toggleSkip, toggleProfilePicture, showPreview,  setShowPreview, hasReviewSuggestions, filterIgnoredSuggestions, ignoreIt, reviewSuggestions, getDefaultPhrases, getPhrases, scanReviewSuggestions, getFieldSuggestionId, showSuggestionPopup}}>
            {props.children}
        </ResumeContext.Provider>)
}//
//export default ResumeContext;
export const useResume = () => {
    const context = useContext(ResumeContext);
    return context;
}
